import escapeStringRegexp from 'escape-string-regexp';

const REPLACES = [['PATTERN_REPLACE_ANY', '*', '.*?'], ['PATTERN_REPLACE_ONE', '?', '.']];

export default function(pattern, flags = 'i', pre = '') {
    let substitute = pattern;

    for (const [key, repeater] of REPLACES) {
        substitute = substitute.replaceAll(repeater, key);
    }

    substitute = escapeStringRegexp(substitute);

    for (const [key, , pattern] of REPLACES) {
        substitute = substitute.replaceAll(key, pattern);
    }

    return new RegExp(pre + substitute, flags);
}
